import { Injectable } from '@angular/core';
import { Database, DatabaseReference, DataSnapshot, onValue, ref, remove, set } from '@angular/fire/database';
import { Observable } from 'rxjs';

/** The service called upon to facilitate unit testing of AbstractRealtimeDatabaseService */
@Injectable()
export class FirebaseWrapper {
  constructor(private database: Database) {}

  ref(path: string): DatabaseReference {
    return ref(this.database, path);
  }

  onValue(path: string): Observable<DataSnapshot> {
    return new Observable<DataSnapshot>((subscriber) => {
      return onValue(
        ref(this.database, path),
        (snapshot) => subscriber.next(snapshot),
        (error) => subscriber.error(error)
      );
    });
  }

  setAsync(path: string, item: any): Promise<void> {
    return set(ref(this.database, path), item);
  }

  removeAsync(path: string): Promise<void> {
    return remove(ref(this.database, path));
  }
}
